import React from 'react';
import {
  StackLayout,
  Button,
  HeadingText,
  ParagraphText,
  ImageMessage,
} from '@leagueplatform/genesis-core';
import paperlessImg from 'assets/paperless.svg';
import {
  buttonStyles,
  linkStyles,
  stackLayoutStyles,
} from 'data/paperless-confirmation-modal.data';
import { LinkComponent } from 'components/form-center/custom-link.component';
import { LocalesKey } from 'common/types';
import { usePaperlessConfirmationModal } from 'hooks/use-paperless-confirmation-modal.hook';
import { BaseModalContainer } from './common/base-modal.component';

interface ModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

export const PaperlessConfirmationModal: React.FC<ModalProps> = ({
  onClose,
  onConfirm,
}) => {
  const { formattedContent } = usePaperlessConfirmationModal();

  return (
    <BaseModalContainer
      footer={
        <StackLayout
          orientation={{ '@initial': 'horizontal', '@mobile': 'vertical' }}
          spacing="$oneAndHalf"
          verticalAlignment="stretch"
          horizontalAlignment="stretch"
          css={stackLayoutStyles}
        >
          <Button css={buttonStyles} onClick={onClose} priority="secondary">
            {formattedContent.cancelButton}
          </Button>
          <Button css={buttonStyles} onClick={onConfirm}>
            {formattedContent.confirmButton}
          </Button>
        </StackLayout>
      }
    >
      <ImageMessage image={paperlessImg}>
        <HeadingText
          level="2"
          size={{ '@initial': 'lg', '@mobile': 'xl' }}
          css={{
            paddingBlock: '$one',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {formattedContent.title}
        </HeadingText>
        {formattedContent.descriptions.map((desc, index) =>
          desc.isLink ? (
            <LinkComponent
              key={desc.id}
              text={desc.id as LocalesKey}
              url={desc.url}
              target={desc.target}
              linkProps={{
                ...linkStyles,
                marginBottom:
                  index === formattedContent.descriptions.length - 1
                    ? '$oneAndHalf'
                    : undefined,
              }}
            />
          ) : (
            <ParagraphText key={desc.id} css={{ textAlign: 'center' }}>
              {desc.text}
            </ParagraphText>
          ),
        )}
      </ImageMessage>
    </BaseModalContainer>
  );
};
